import { FC } from "react";

import styles from "./IndicatorsTabs.module.css";

export type IndicatorsTab = "favorites" | "current" | "all";

interface IndicatorsTabsProps {
  active: IndicatorsTab;
  currentCount: number;
  favoritesCount: number;
  onChange: (tab: IndicatorsTab) => void;
}

export const IndicatorsTabs: FC<IndicatorsTabsProps> = ({
  active,
  currentCount,
  favoritesCount,
  onChange,
}) => (
  <div className={styles.tabs}>
    {favoritesCount > 0 && (
      <button
        className={`${styles.tab} ${active === "favorites" ? styles.tabActive : ""}`}
        onClick={() => onChange("favorites")}
      >
        Favorites
      </button>
    )}
    {currentCount > 0 && (
      <button
        className={`${styles.tab} ${active === "current" ? styles.tabActive : ""}`}
        onClick={() => onChange("current")}
      >
        Current ({currentCount})
      </button>
    )}
    <button
      className={`${styles.tab} ${active === "all" ? styles.tabActive : ""}`}
      onClick={() => onChange("all")}
    >
      All
    </button>
  </div>
);
